module.exports = __webpack_public_path__ + "img/home_head_sm_bg.8fedea6b.png";